import {
  UserOutlined,
  PlayCircleOutlined,
  LockOutlined,
  QuestionCircleOutlined,
  LogoutOutlined,
  BgColorsOutlined,
  DeleteOutlined,
  DollarOutlined, // Added for theme icon
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import React, { ReactNode, useState } from "react"; // Added useState
import ThemeSelectionModal from "../sharedcomponents/ThemeSelectionModal"; // Added ThemeSelectionModal
import { IAuthType } from "../../apiservice/authService.type";
import { useAppSelector } from "../../Redux/reduxCustomHook";
import { RootState } from "../../Redux/store";
import "./User-Profile-Comp.css";
import { Modal } from "antd";
import { sampleApiCall } from "../../apiservice/authService";
import { appZIndex } from "../../utils/appconst";
import { userDeleteAccount } from "../../apiservice/userService";

export const UserProfileSettingComp = () => {
  const navigate = useNavigate();
  const [isThemeModalOpen, setThemeModalOpen] = useState(false); // Added state for modal

  // Show Confirm with navigation on a new tab
  const showDeleteConfirm = (
    title: string,
    content: ReactNode,
    url: string
  ) => {
    Modal.confirm({
      title,
      content,
      async onOk() {
        try {
          // Perform account deletion using axios with await
          await userDeleteAccount({});

          // Show success message
          // message.success(
          //   "Your delete request has been created. An email will be sent to you once your account has been fully deleted from our system. You don't need to perform any other action."
          // );

          alert(
            "Your delete request has been created. An email will be sent to you once your account has been fully deleted from our system. You don't need to perform any other action."
          );

          // Redirect after successful deletion
          handleNavigation(url);
        } catch (err) {
          console.error("Account deletion failed", err);

          alert("Failed to send the delete request. Please try again.");
          // Show error message in case of failure
          // message.error("Failed to send the delete request. Please try again.");
        }
      },
      onCancel() {
        console.log("Cancelled");
      },
      zIndex: appZIndex.modal,
    });
  };

  const menuItems = [
    {
      icon: <UserOutlined />,
      text: "Manage Profile",
      path: "/users/editprofile",
    },
    {
      icon: <DollarOutlined />,
      text: "Subscription",
      path: "/users/subscription",
    },
    {
      icon: <DollarOutlined />,
      text: "Transactions",
      path: "/users/transactions",
    },
    {
      icon: <PlayCircleOutlined />,
      text: "Getting Started",
      path: "/users/getStarted",
    },
    {
      icon: <LockOutlined />,
      text: "Change Password",
      path: "/users/change-password",
    },
    {
      icon: <QuestionCircleOutlined />,
      text: "Help Center",
      path: "/users/helpcenter",
    },
    {
      icon: <BgColorsOutlined />, // Theme icon
      text: "Theme",
      action: () => setThemeModalOpen(true), // Action to open modal
    },
    {
      icon: <LogoutOutlined />,
      text: "Logout",
      path: "/users/logout",
    },
    {
      icon: <DeleteOutlined className="text-red-600" />, // Use Delete icon
      text: "Delete Account",
      isAccountDelete: true,
      action: () => {
        showDeleteConfirm(
          "Delete Account",
          "Are you sure you want to delete your account? This action cannot be undone.",
          "/users/logout"
        );
      },
      className: "text-red-600", // Red color for the delete button
    },
  ];

  const handleNavigation = (path?: string, action?: () => void) => {
    if (path) {
      navigate(path);
    } else if (action) {
      action();
    }
  };

  const authData: IAuthType = useAppSelector(
    (state: RootState) => state?.AuthData
  );
  return (
    <>
      <div className="grid p-4">
        <p className="pt-2 pb-8 font-sans text-md text-gray-900 dark:text-gray-200">
          {authData?.data?.credentials?.fullName ||
            `${authData?.data?.credentials?.firstName} ${authData?.data?.credentials?.lastName}`}
        </p>

        {menuItems.map((item, index) => (
          <div
            key={index}
            onClick={() => handleNavigation(item.path, item.action)} // Modified to handle action
            className="flex items-center p-2 pt-4 pb-4 border-t hover:bg-gray-100 dark:hover:bg-stone-700 cursor-pointer font-sans"
          >
            <div className="text-xl text-gray-600 dark:text-gray-400">
              {item.icon}
            </div>
            <span className="pl-4 fontAlbertSansRegular text-md font-medium text-gray-900 dark:text-gray-200">
              {item.text}
            </span>
          </div>
        ))}
      </div>
      <ThemeSelectionModal
        isOpen={isThemeModalOpen}
        onClose={() => setThemeModalOpen(false)}
      />
    </>
  );
};

export default UserProfileSettingComp;
